import PlazoDias from './plazodias.vue';
import PlazoDiasForm from './plazodias-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/plazodias/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('plazodias', [], PlazoDias),
        keepAlive: true
    },
    {
        path: '/plazodias/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('plazodias/new', [], PlazoDiasForm)
    },
    {
        path: '/plazodias/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('plazodias/edit', [], PlazoDiasForm)
    },
    {
        path: '/plazodias/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('plazodias/view', [], PlazoDiasForm, { editable: false })
    },
];
export default routes;